import React, { useContext } from "react";
import { Spinner } from "react-bootstrap";
import PsContext from "../../context";
import { apiFolderFileLinks } from "../../utils";

const GlobalLoader = () => {
  const context = useContext(PsContext);
  const centralImg = context.settingValue("web_site_loader_image");
  const clgName = context.settingValue("web_site_name");

  const imageUrl = centralImg ? apiFolderFileLinks(centralImg) : null;

  // console.log("sssssss", imageUrl);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "#ffffff",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <style>
        {`
                @keyframes spin {
                    from { transform: rotate(0deg); }
                    to { transform: rotate(360deg); }
                }
                .rotating-text-container {
                    animation: spin 8s linear infinite;
                    position: absolute;
                    width: 200px; 
                    height: 200px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                `}
      </style>

      <div
        style={{
          position: "relative",
          width: "200px",
          height: "200px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {imageUrl ? (
          <img
            src={imageUrl}
            alt="College Logo"
            style={{
              width: "80px",
              height: "80px",
              objectFit: "contain",
              borderRadius: "50%",
              zIndex: 2,
            }}
          />
        ) : (
          <Spinner
            animation="border"
            role="status"
            style={{ width: "3rem", height: "3rem", zIndex: 2 }}
          >
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        )}

        {clgName && (
          <div className="rotating-text-container">
            <svg viewBox="0 0 200 200" width="200" height="200">
              <defs>
                <path
                  id="circlePath"
                  d="M 100, 100 m -75, 0 a 75,75 0 1,1 150,0 a 75,75 0 1,1 -150,0"
                />
              </defs>
              <text fill="#000" fontSize="14" fontWeight="bold">
                <textPath href="#circlePath" startOffset="0%">
                  {clgName} • {clgName} •
                </textPath>
              </text>
            </svg>
          </div>
        )}
      </div>
    </div>
  );
};

export default GlobalLoader;
